import React from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Abstand zwischen zwei Events in Meine Events (30.10.2026, Wunsch Phil): eine graue Linie mit
 * Pfeil nach unten auf Höhe der Datumskacheln, daneben „54 Tage · 7 Wochen“. Hilft beim Planen
 * der Vorbereitung; gerechnet in `plannerAbstand` (shared/planner.ts).
 */
export default function PlannerAbstand({ label }: { label: string }) {
  return (
    <div className="planner-abstand" aria-label={`Abstand zum nächsten Event: ${label}`}>
      <span className="planner-abstand-linie" aria-hidden><ChevronDown size={14} strokeWidth={2} absoluteStrokeWidth /></span>
      <span className="planner-abstand-text">{label}</span>
    </div>
  );
}
